import { SERVICES, whatsappLink } from "../../data";
import { SectionHeading, Reveal } from "./Shared";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 px-6 bg-[#151c0f]"
    >
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Signature Treatments"
          title="Care for Body, Skin & Soul"
          subtitle="Each ritual is performed with intention — blending traditional Thai technique with warm, therapeutic touch to melt away the everyday."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-20">
          {SERVICES.map((s, i) => (
            <Reveal key={s.name} delay={(i % 3) * 0.1}>
              <article
                data-testid={`service-card-${i}`}
                className="hover-lift group h-full bg-[#2d3a1f] border border-[#b89d62]/25 overflow-hidden flex flex-col"
              >
                <div className="relative h-60 overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.name}
                    className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2d3a1f] via-transparent to-transparent" />
                  <span className="absolute top-4 right-4 bg-[#151c0f]/80 backdrop-blur text-[#b89d62] px-3 py-1 eyebrow border border-[#b89d62]/30">
                    {s.price}
                  </span>
                </div>
                <div className="p-7 flex flex-col flex-1">
                  <h3 className="font-serif-display text-2xl text-[#faf9f6] font-light">
                    {s.name}
                  </h3>
                  <p className="mt-3 text-sm text-[#c9d3ca] font-light leading-relaxed flex-1">
                    {s.desc}
                  </p>
                  <a
                    data-testid={`service-book-${i}`}
                    href={whatsappLink(`Hola Royale, me interesa ${s.name}. ¿Tienen disponibilidad?`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 inline-flex items-center gap-2 text-[#b89d62] hover:text-[#d4af37] eyebrow transition-colors"
                  >
                    Book this ritual →
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
